import axios from 'axios'
import store from '@/store/index'
import router from '@/router/index'
import { Message } from 'element-ui'

axios.interceptors.request.use(
  config => {
    if (store.state.token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.token = store.state.token
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

axios.interceptors.response.use(
  response => {
    if (response.data.data && response.data.data.isLogin === false) {
      // tips('登録に失敗しました、再度登録してください')
      store.dispatch('setToken', '')
    }
    if (response.data.code === -10) {
      Message.error('当前版本过老，请更新');
      return
    }
    if (response.data.code === -11) {
      Message.error(response.data.msg);
      return
    }
    if (response.data.code === -3) {
      // tips(response.data.msg)
      store.commit('set_user_info',{})
      store.commit('set_token','')
      router.push('/index')
    }
    if (response.data.code === -8) {
      // tips(response.data.msg)
      store.commit('set_user_info',{})
      store.commit('set_token','')
      router.push('/index')
    }
    if (response.data.success === false) {
      if(response.data.code == -8){

      }else if (response.data.msg !== '超时' && response.data.msg !== 'タイムアウト') {
        Message.error(response.data.msg);
        // tips(response.data.msg, 1500, 'error')
      }
    }
    return response
  },
  error => {
    if (error.data && error.data.msg) {
      Message.error(response.data.msg);
      // tips(error.data.msg, 2500, 'error')
    } else {
      // tips('タイムアウト')
    }
    return error
  }
)